<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20.087" viewBox="0 0 24 20.087">
    <g transform="translate(-948 -529.913)">
      <path class="a" d="M17,21V19a4,4,0,0,0-4-4H5a4,4,0,0,0-4,4v2" transform="translate(948 528)"/>
      <circle class="a" cx="4" cy="4" r="4" transform="translate(953 531)"/>
      <path class="a" d="M23,21V19a4,4,0,0,0-3-3.87" transform="translate(948 528)"/>
      <path class="a" d="M16,3.13a4,4,0,0,1,0,7.75" transform="translate(948 528)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "GroupIcon"
}
</script>

<style scoped>
.a {
  fill: none;
  stroke: #fff;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
